module.exports = __webpack_public_path__ + "img/icon_instagram_rotate_txt.c71de1da.svg";